<template lang="pug">
  .footer.redesignPrimaryDarken
    .container
      div
        logo-heading(color="redesignControlsBackground")
        footer-menu.footer__menu(:links="links")
        .footer__rights
          router-link.footer__link(:to="$conf.PRIVACY_POLICY") Политика конфиденциальности
          p.body-2.redesignPrimaryLighten--text и
          router-link.footer__link(:to="$conf.USER_AGREEMENT") пользовательское соглашение
          //- router-link.footer__link(to="") Политика конфиденциальности
      div
        .footer__contacts(v-if="Object.keys(event.organization || {}).length")
          span.footer__title Контакты
          .footer__contacts-list
            a.footer__contacts-item(
              v-if="event.organization.contact_email"
              :href="`mailto:${event.organization.contact_email}`"
            )
              v-icon.footer__icon(size="24" color="redesignPrimary") $imail
              span.footer__contacts-label {{ event.organization.contact_email }}
            a.footer__contacts-item(
              v-if="event.organization.contact_phone"
              :href="`tel:+7${event.organization.contact_phone}`"
            )
              v-icon.footer__icon(size="24" color="redesignPrimary") $iphone-call
              span.footer__contacts-label {{ event.organization.contact_phone }}

      //-   .footer__app
      //-     span.footer__title Скачать приложение
      //-     .footer__app-list
      //-       button.footer__app-btn
      //-         v-img(src="@/assets/google-play.png")
      //-       button.footer__app-btn
      //-         v-img(src="@/assets/app-store.png")

      //- div
      //-   .footer__social
      //-     span.footer__title Мы в социальных сетях:
      //-     .footer__social-list
      //-       a.footer__contacts-item(href="")
      //-         v-icon.footer__icon(size="24" color="redesignPrimary") $itelegram
      //-       a.footer__contacts-item(href="tel:+79141910627")
      //-         v-icon.footer__icon(size="24" color="redesignPrimary") $ivk
</template>

<script>
import LogoHeading from '@/components/user-redesign/layout/TheHeader/LogoHeading.vue';
import FooterMenu from './footer/FooterMenu.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SectionFooter',
  components: {
    LogoHeading,
    FooterMenu,
  },
  props: {
    event: { type: Object, default: () => ({}) },
    availableSections: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters({
      links: 'redesignHeaderLinks/getLinks',
    }),
  },
};
</script>

<style lang="scss" scoped>
.footer {
  padding-top: 32px;
  padding-bottom: 74px;

  .container {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 30px;

    @media (min-width: $md) {
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
    }
  }

  &__menu {
    margin-top: 61px;
  }

  &__rights {
    display: flex;
    gap: 16px;
    margin-top: 89px;
  }

  &__link {
    position: relative;
    color: #{$redesignPrimaryLighten};
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: underline;
    opacity: 1 !important;
    transition: color 0.2s;

    &:hover {
      color: #{$redesignControlsBackground};
    }

    &:not(:first-child):before {
    //  content: '';
    //  position: absolute;
    //  top: calc(50% - 2px);
    //  left: -10px;
    //  display: block;
    //  width: 4px;
    //  height: 4px;
    //  background-color: #{$redesignPrimaryLighten};
    //  border-radius: 50%;
    }
  }

  &__title {
    color: #{$redesignControlsBackground};
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  &__icon {
    position: relative;
    z-index: 2;

    &:before {
      content: '';
      position: absolute;
      z-index: -1;
      width: 32px;
      height: 32px;
      background-color: #{$redesignPrimaryLighten};
      border-radius: 50%;
      transition: background-color 0.2s;
    }
  }

  &__contacts {
  }

  &__contacts-list {
    display: flex;
    gap: 20px;
    margin-top: 20px;
  }

  &__contacts-item {
    display: flex;
    gap: 12px;
    opacity: 1 !important;

    &:hover {
      .footer__icon:before {
        background-color: $redesignControlsBackground;
      }

      .footer__contacts-label {
        color: $redesignControlsBackground;
      }
    }
  }

  &__contacts-label {
    color: #{$redesignPrimaryLighten};
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: lowercase;
    transition: color 0.2s;
  }

  &__social-list {
    display: flex;
    gap: 20px;
    margin-top: 20px;
  }

  &__app {
    margin-top: 38px;
  }

  &__app-list {
    margin-top: 20px;
    display: flex;
    gap: 16px;
  }

  &__app-btn {
    display: inline-block;
    width: 160px;
    height: 47px;
  }
}
</style>
